(function(){
  // scroll reveal
  if('IntersectionObserver' in window){
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}});},{threshold:.12,rootMargin:'0px 0px -8% 0px'});
    function bind(){document.querySelectorAll('.reveal:not(.in)').forEach(function(el,i){el.style.transitionDelay=(Math.min(i%4,3)*60)+'ms';io.observe(el);});}
    bind(); document.addEventListener('shopify:section:load',bind);
  } else { document.querySelectorAll('.reveal').forEach(function(el){el.classList.add('in');}); }
  // mobile menu
  document.addEventListener('click',function(e){
    var t=e.target.closest('[data-menu-open]'); if(t){document.documentElement.classList.add('menu-on');}
    if(e.target.closest('[data-menu-close]')||e.target.classList.contains('mnav__scrim')){document.documentElement.classList.remove('menu-on');}
  });
})();
